/**
 * Animations GSAP centralisées
 * Utilisez les classes CSS pour déclencher les animations
 */

class Animations {
  constructor() {
    this.init();
  }

  init() {
    // Vérifier que GSAP et ScrollTrigger sont disponibles
    if (typeof gsap === "undefined") {
      console.warn("GSAP not loaded");
      return;
    }

    if (typeof ScrollTrigger === "undefined") {
      console.warn("ScrollTrigger not loaded");
      return;
    }

    // Enregistrer ScrollTrigger
    gsap.registerPlugin(ScrollTrigger);

    // Initialiser les animations
    this.initFadeInAnimations();
    this.initScaleAnimations();
    this.initStaggerAnimations();
    this.initParallaxAnimations();
  }

  /**
   * Animation de fade in
   */
  initFadeInAnimations() {
    // Fade in simple
    gsap.utils.toArray(".fade-in").forEach((element) => {
      gsap.fromTo(
        element,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: element,
            start: "top 75%",
            end: "bottom 20%",
            // toggleActions: "play none none reverse",
          },
        }
      );
    });
  }

  /**
   * Animation de zoom au scroll
   */
  initScaleAnimations() {
    // zoom-in-scroll
    gsap.utils.toArray(".zoom-in-scroll").forEach((element) => {
      gsap.fromTo(
        element,
        { scale: 1 },
        {
          scale: 1.2,
          ease: "none",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            end: "bottom 20%",
            scrub: true,
          },
        }
      );
    });
  }

  /**
   * Animations avec stagger (pour les listes)
   */
  initStaggerAnimations() {
    // Fade in stagger
    gsap.utils.toArray(".fade-in-stagger").forEach((container) => {
      const items = container.querySelectorAll(".stagger-item");
      gsap.fromTo(
        items,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: container,
            start: "top 75%",
            end: "bottom 20%",
            // toggleActions: "play none none reverse",
          },
        }
      );
    });

    // Slide in stagger
    gsap.utils.toArray(".slide-in-stagger").forEach((container) => {
      const items = container.querySelectorAll(".stagger-item");
      gsap.fromTo(
        items,
        { x: -50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: container,
            start: "top 80%",
            end: "bottom 20%",
            // toggleActions: "play none none reverse",
          },
        }
      );
    });
  }

  /**
   * Animations parallax
   */
  initParallaxAnimations() {
    // Parallax simple
    gsap.utils.toArray(".parallax").forEach((element) => {
      gsap.to(element, {
        yPercent: -15,
        ease: "none",
        scrollTrigger: {
          trigger: element,
          start: "top 80%",
          end: "bottom 20%",
          scrub: true,
        },
      });
    });

    // Parallax inverse
    gsap.utils.toArray(".parallax-reverse").forEach((element) => {
      gsap.to(element, {
        yPercent: 15,
        ease: "none",

        scrollTrigger: {
          trigger: element,
          start: "top 80%",
          end: "bottom 20%",
          scrub: true,
        },
      });
    });
  }
}

// Helper to get current breakpoint (customize as needed)
function getBreakpoint() {
  // Example: 768px is the mobile/desktop breakpoint
  return window.innerWidth < 768 ? 'mobile' : 'desktop';
}

let currentBreakpoint = getBreakpoint();

// Initialiser les animations quand le DOM est prêt
document.addEventListener("DOMContentLoaded", () => {
  window.Animations = new Animations();
});

// Réinitialiser pour les sections Shopify
document.addEventListener("shopify:section:load", (event) => {
  if (window.Animations) {
    window.Animations.init();
  }
});

// Re-init animations on breakpoint change after resize
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const newBreakpoint = getBreakpoint();
    if (newBreakpoint !== currentBreakpoint) {
      currentBreakpoint = newBreakpoint;
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      }
      if (window.Animations) {
        window.Animations.init();
      }
    }
  }, 200); // Debounce for performance
});

// Exposer la classe globalement
window.AnimationsClass = Animations;
